<template>
	<div id="InviteCard" v-show="showcont">
		<img id="imgecard" :src="imgSrc" @click="changeThem" />
		<a class="u-btn" @click="changeThem">更换邀请卡主题</a>
		<div class="context">
			<p class="Label">如何玩转邀请卡</p>
			<p class="text">
				1.公开话题/加密话题邀请好友来看直播，榜上有名;<br/> 2.长按保存图片发送给好友即可邀请;
				<br/> 3.点击"更换邀请卡主题"，切换邀请卡主题样式。
				<br/>
			</p>
		</div>
	</div>
</template>

<script>
	import QRCoder from 'qrcoder';
	import { Toast } from 'vant';
	
	// import blue  from  '../../../statics/imgs/yaoqingblue.jpg';
	// import red  from  '../../../statics/imgs/yaoqingred.jpg';
	// import black  from  '../../../statics/imgs/yaoqingblack.jpg';
	
	
	//保存数据
	import vxxData from '../../kits/data.js';
	import tool from '../../kits/Tools.js';
	export default {
		data() {
			return {
				initData: {},
				currentIndex: 0,
				theme: ["","",""],//[blue,red,black],
				base64URLData: "",
				showcont: false,
				fans_id: '',
				headImg: '',
				titleRect: '',
				timeRect: '',
				infoRect: '',
				ctx: '',
				imgSrc: '',
				qrcodeurl: '',
				livetime: '',
				titleStr: '',
				descStr: '',
				canvas: ''
			}
		},
		mounted() {
			Toast.loading({
				mask: true,
				message: '加载中...'
			});
			this.initData = vxxData.getInitData();
			if(!this.initData) {
				this.$router.push({
					name: 'home'
				});
				return;
			}
			var current_app_Id = window.localStorage.getItem("current_app_Id");
			var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
			this.fans_id = fans.fans_id;
			var direct_seeding = this.initData.direct_seeding;
			var startTime = direct_seeding.start_time;
			if(startTime) {
				this.livetime = "直播时间：" + startTime.substr(0, 4) + "年" + startTime.substr(5, 2) + "月" + startTime.substr(8, 2) + "日 " + startTime.substr(11, 2) + startTime.substr(13, 3)
			}
			this.titleStr = direct_seeding.name;
			this.descStr = direct_seeding.desc;
			this.qrcodeurl = "http://ph.shikee.tv/?ds_id=" + direct_seeding.ds_id + "#/home/" + this.fans_id;
			this.canvas = document.createElement("canvas");
			this.canvas.width = 750;
			this.canvas.height = 1330;
			this.ctx = this.canvas.getContext("2d");
			this.getHeadImg();
		},
		methods: {
			changeThem() {
				this.currentIndex++;
				if(this.currentIndex > 2) {
					this.currentIndex = 0;
				}
				this.drawBackgroud();
			},
			getHeadImg() {
				var that = this;
				var avatorimage = tool.baseUrl() + "/fans/invite/getImg/?fans_id=" + this.fans_id;
				this.axios.post(avatorimage).then(function(res) {
					that.base64URLData = res.data;
					that.drawBackgroud();
				}).catch(function(res) {
					console.log(res)
				})
			},
			drawBackgroud() {
				//绘制背景图片
				var that = this;
				var img = new Image();
				img.src = this.theme[this.currentIndex];

				this.headImg = {
					x: 296,
					y: 197,
					width: 149,
					height: 149
				};
				this.titleRect = {
					y: 454,
					width: 382
				};
				this.timeRect = {
					x: 121,
					y: 700
				};
				this.infoRect = {
					x: 112,
					y: 860,
					width: 450,
					height: 28
				};

				if(this.currentIndex == 2) {
					this.headImg = {
						x: 305,
						y: 260,
						width: 130,
						height: 130
					};
					this.timeRect = {
						x: 132,
						y: 680
					};
					this.infoRect = {
						x: 112,
						y: 798,
						width: 450,
						height: 28
					};
				}

				img.onload = function() {
					that.ctx.drawImage(img, 0, 0);
					that.drawHeadImage();
				}
			},
			drawHeadImage() {
				//头像
				var img3 = new Image();
				var that = this;
				var ctx = this.ctx;
				var headImg = this.headImg;
				var infoRect = this.infoRect;
				var color = '#333333';
				img3.src = that.base64URLData;

				img3.onload = function() {
					ctx.save();
					ctx.arc(headImg.x + (headImg.width / 2.0), headImg.y + (headImg.height / 2.0), headImg.width / 2.0, 0, Math.PI * 2, true);
					ctx.clip();
					ctx.drawImage(img3, headImg.x, headImg.y, headImg.width, headImg.height);
					ctx.restore();
					//titleStr
					that.drawMultilineText(that.titleStr, ctx, 750, that.titleRect.y, that.titleRect.width, 50, 10, "48px PingFangSC-Regular", color, true);

					that.drawSingleLineText(that.livetime, ctx, that.timeRect.x, that.timeRect.y, "30px PingFangSC-Regular", color);

					that.drawMultilineText(that.descStr, ctx, infoRect.x, infoRect.y, infoRect.width, infoRect.height, 14, "28px PingFangSC-Regular", color, false);

					that.drawleftImage();
				};
			},
			drawSingleLineText(text, ctx, x, y, font, color) {
				//绘制单行文字
				ctx.font = font;
				ctx.fillStyle = color;
				ctx.fillText(text, x, y);
			},
			drawMultilineText(t, ctx, bgWidth, y, w, lineHeight, spaceLine, font, color, isCenter) {
				//绘制多行文字
				var that = this;
				var chr = t.split("");
				var temp = "";
				var row = [];

				ctx.font = font;
				ctx.fillStyle = color;

				for(var a = 0; a < chr.length; a++) {
					if(ctx.measureText(temp).width < w) {
						temp += chr[a];
					} else {
						temp += chr[a];
						if(row.length < 1) {
							row.push(temp);
							temp = "";
						} else if(row.length == 1) {
							if(that.currentIndex == 2 && !isCenter) {
								row.push(temp.slice(0, -4) + "...");
							} else {
								row.push(temp.slice(0, -1) + "...");
							}
							temp = "";
						} else {
							break;
						}
					}
				}

				row.push(temp);

				for(var b = 0; b < row.length; b++) {
					var xTmp = bgWidth;
					if(isCenter) {
						xTmp = (bgWidth - ctx.measureText(row[b]).width) / 2.0;
					}

					if(b < 2) {
						if(b == 1) {
							y = y + spaceLine;
						}
						if(row.length == 1) {
							y = y + 30;
						}
						ctx.fillText(row[b], xTmp, y + (b + 1) * lineHeight);
					}
				}
			},
			drawleftImage() {
				var img4 = new Image();
				var that = this;
				var ctx = this.ctx;
				const qrcoder = new QRCoder({
					data: this.qrcodeurl,
					size: 225
				});
				img4.src = qrcoder.getDataURL();
				img4.onload = function() {
					ctx.save();
					that.roundedRectPP(ctx, 123, 1034, 215, 215, 10);
					ctx.clip();
					ctx.drawImage(img4, 123, 1034, 215, 215);
					ctx.restore();
					that.imgSrc = that.canvas.toDataURL("image/png");
					that.showcont = true;
					Toast.clear();
				}
			},
			roundedRectPP(ctx, X, Y, W, H, radius) {
				//圆角矩形
				ctx.beginPath();
				if(W > 0) {
					ctx.moveTo(X + radius, Y);
				} else {
					ctx.moveTo(X - radius, Y);
				}
				ctx.arcTo(X + W, Y, X + W, Y + H, radius);
				ctx.arcTo(X + W, Y + H, X, Y + H, radius);
				ctx.arcTo(X, Y + H, X, Y, radius);
				if(W > 0) {
					ctx.arcTo(X, Y, X + radius, Y, radius);
				} else {
					ctx.arcTo(X, Y, X - radius, Y, radius);
				}
				ctx.fill();
			}
		}
	}
</script>

<style scoped>
	#InviteCard {
		padding: 20px;
	}
	
	#imgecard {
		display: block;
		width: 100%;
	}
	
	.Label {
		font-size: 16px;
		padding: 5px 0px;
	}
	
	.text {
		font-size: 13px;
		padding-bottom: 20px;
	}
	
	.u-btn {
		display: block;
		text-align: center;
		padding: 10px;
		color: white;
		margin: 30px auto 10px;
		background-color: #00acff;
		border-radius: 2px;
	}
	
	.u-btn:active {
		background-color: #f44336;
	}
</style>


// WEBPACK FOOTER //
// InviteCard.vue?659ce040